import React from 'react';
import App from '~/App';
import ReactDOM from 'react-dom';
import setupSentry from '~/utils/setupSentry';

setupSentry();

ReactDOM.render(<App />, document.getElementById('root'));
